import type { ViewMeta } from '@blocksuite/data-view';
import { viewConverts, viewPresets } from '@blocksuite/data-view/view-presets';

const DATABASE_CALENDAR_FEATURE_KEY = 'database-calendar';
const DATABASE_CALENDAR_ALLOWED_CLASS = `feature-${DATABASE_CALENDAR_FEATURE_KEY}-allowed`;

export function isDatabaseCalendarViewCreationAllowed(): boolean {
  if (typeof document === 'undefined') return false;
  return document.body.classList.contains(DATABASE_CALENDAR_ALLOWED_CLASS);
}

export const databaseBlockViews: ViewMeta[] = [
  viewPresets.tableViewMeta,
  viewPresets.kanbanViewMeta,
  viewPresets.ganttViewMeta,
  viewPresets.calendarViewMeta,
];

export function getCreatableDatabaseBlockViews(): ViewMeta[] {
  return databaseBlockViews.filter(
    view =>
      view.type !== viewPresets.calendarViewMeta.type ||
      isDatabaseCalendarViewCreationAllowed()
  );
}

export const databaseBlockViewMap = Object.fromEntries(
  databaseBlockViews.map(view => [view.type, view])
);
export const databaseBlockViewConverts = [...viewConverts];
